module.exports = __webpack_public_path__ + "img/icon-meh.b50090b4.svg";